import '../Home.css';
import RegionDisplay from './RegionDisplay';
import HomeFooter from '../HomeFooter';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div
      className="page"
      data-page-lang="fr"
      data-page-id="home"
      data-page-id-num="4727"
      id="page-home"
      data-page-nav="home"
    >
      <div className="page-content">
        <header className="site-header quebec-header">
          <h1 className="site-header-seo-title">Accueil | 211 Québec</h1>
          <div className="site-centerer quebec-header-inner flexbox flex-flow-row-no-wrap flex-stretch">
            <div className="site-header-col-left flexbox">
              <a
                className="site-header-logo flexbox flex-flow-row-no-wrap flex-align-items-center"
                hrefLang="fr"
                href=""
              >
                <img
                  alt="211 Québec"
                  src="/images/logos/logo.png"
                  className="site-header-logo-qc"
                />
                <img
                  alt="211 Québec"
                  src="/images/logos/logo-meta.png"
                  className="site-header-logo_respo"
                />
              </a>
              <div className="label-logo flexbox flex-center">
                Information on community, public and parapublic services
              </div>
            </div>
            <div className="quebec-header-col-right flexbox flex-flow-row-no-wrap flex-stretch">
              <div className="side-button lang flex-flex flexbox flex-flow-column-no-wrap">
                <Link className="site-header-info-lang flexbox flex-center flex-flex" to="/fr/home" hrefLang="fr">
                  Français
                </Link>
              </div>
            </div>
          </div>
        </header>

        <div className="find-ressources-ctn">
          <a className="center-text margin-vert find-ressources" href="javascript:void()">
            <span>TO FIND RESOURCES</span>
            <span>SELECT THE DATABASE OF YOUR REGION</span>
          </a>
        </div>

        {/* INSERTING RegionPage here */}
        <div className="main-content">
          <RegionDisplay />
          <HomeFooter/>
        </div>

        {/* Your footer can go here as another component or as JSX as needed */}
      </div>
    </div>
  );
};

export default Home;
